import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useStateValue } from "../../session/store";

//dos varibles globales firebase y sesion
function AuthPath({ component: Component, signinFirebase, ...rest }) {
  //variable global de sesion
  const [{ signin }, dispatch] = useStateValue();

  return (
    <Route
      {...rest}
      render={props =>
        signin === true || signinFirebase !== null ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to="/auth/login" />
        )
      }
    />
  );
}

export default AuthPath;
